import React from "react";
import UndoIcon from "../../../../../../../../../assets/svg/v1/undo-icon";
import RedoIcon from "../../../../../../../../../assets/svg/v1/redo-icon";
import FontSizeIcon from "../../../../../../../../../assets/svg/v1/font-size-icon";
import TextColorPickerIcon from "../../../../../../../../../assets/svg/v1/text-color-picker-icon";
import AlignLeftIcon from "../../../../../../../../../assets/svg/v1/align-left-icon";
import IndentLeftIcon from "../../../../../../../../../assets/svg/v1/indent-left-icon";
import IndentRightIcon from "../../../../../../../../../assets/svg/v1/indent-right-icon";
import ChevronDownSolidIcon from "../../../../../../../../../assets/svg/v1/chevron-down-solid-icon";
import AttachFilesIcon from "../../../../../../../../../assets/svg/v1/attach-files-icon";
import BoldIcon from "../../../../../../../../../assets/svg/bold-icon";
import ItalicsIcon from "../../../../../../../../../assets/svg/italics-icon";
import UnderlineIcon from "../../../../../../../../../assets/svg/underline-icon";
import StrikeThroughIcon from "../../../../../../../../../assets/svg/strikethrough-icon";
import UnorderedListIcon from "../../../../../../../../../assets/svg/unordered-list-icon";
import MentionsIcon from "../../../../../../../../../assets/svg/mentions-icon";
import LinkIcon from "../../../../../../../../../assets/svg/link-icon";

const Divider: React.FC = () => (
  <div className="mx-[6px] h-[19px] w-px bg-border-gray dark:bg-border-gray-dk shrink-0" />
);

const TicketDescriptionDisabledToolbar: React.FC = () => {
  return (
    <div
      aria-hidden="true"
      className="flex items-center py-1.5 px-3 gap-1 pointer-events-none border-t border-border-gray dark:border-border-gray-dk select-none opacity-50 overflow-x-auto"
    >
      <div className="rounded">
        <UndoIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
      </div>
      <div className="rounded">
        <RedoIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
      </div>

      <Divider />

      <div className="flex items-center gap-x-2 py-1 text-sm font-medium text-verba-indigo dark:text-verba-indigo-dk">
        <span className="truncate">Sans Serif</span>
        <ChevronDownSolidIcon className="w-[10px] h-[5px] text-verba-indigo dark:text-verba-indigo-dk" />
      </div>

      <Divider />

      <div className="flex items-center gap-x-1 text-dark-gray dark:text-dark-gray-dk">
        <FontSizeIcon className="w-[18px] h-[18px] text-dark-gray dark:text-dark-gray-dk" />
        <ChevronDownSolidIcon className="w-[10px] h-[5px] text-dark-gray dark:text-dark-gray-dk" />
      </div>

      <Divider />

      <div className="flex items-center gap-x-2.5">
        <div className="rounded">
          <BoldIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
        </div>
        <div className="rounded">
          <ItalicsIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
        </div>
        <div className="rounded">
          <UnderlineIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
        </div>
        <div className="rounded">
          <StrikeThroughIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
        </div>
      </div>

      <div className="p-1 rounded flex items-center justify-between space-x-1">
        <TextColorPickerIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
        <ChevronDownSolidIcon className="w-[10px] h-[5px] text-gray-placeholder dark:text-gray-placeholder-dk" />
      </div>

      <Divider />

      <div className="flex items-center gap-x-1 rounded-[4px] mr-2.5">
        <UnorderedListIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
        <ChevronDownSolidIcon className="w-[10px] h-[5px] text-gray-placeholder dark:text-gray-placeholder-dk" />
      </div>

      <div className="flex items-center gap-x-1 rounded-[4px]">
        <AlignLeftIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
        <ChevronDownSolidIcon className="w-[10px] h-[5px] text-gray-placeholder dark:text-gray-placeholder-dk" />
      </div>

      <Divider />

      <div className="flex items-center gap-x-[11px]">
        <div className="rounded">
          <IndentLeftIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
        </div>
        <div className="rounded">
          <IndentRightIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
        </div>
        <div className="rounded">
          <MentionsIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
        </div>
        <div className="rounded">
          <LinkIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
        </div>
      </div>

      <Divider />

      <div className="shrink-0 flex items-center gap-1 rounded-[4px] px-2 py-1 text-verba-blue dark:text-verba-blue-dk bg-hover-effect dark:bg-hover-effect-dk">
        <AttachFilesIcon className="w-[14px] h-[14px] shrink-0" />
        <span className="text-sm font-medium whitespace-nowrap">
          Upload file
        </span>
      </div>
    </div>
  );
};

export default TicketDescriptionDisabledToolbar;
